import styled from 'styled-components';

export const FormWrapper = styled.div`
  width: 100%;
`;

export const SettingsHeaderWrapper = styled.div`
  padding-bottom: 19px;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const BoldWrapper = styled.b`
  color: ${(p) => p.theme.colors.text};
`;

export const UserFieldWrapper = styled.div`
  margin-bottom: 16px;
`;

export const DeleteUserSubtitle = styled.p`
  margin: 0;
  ${(props) => props.theme.typography.notification};
`;

export const SuccessModalWrapper = styled.div`
  padding-top: 32px;
  margin-bottom: 32px;
  text-align: center;
`;

export const DeleteClientSubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  margin-bottom: 8px;
`;
